module.exports = __webpack_public_path__ + "static/media/mountain-callling-01.a1033b9c.jpg";